import { observable, computed } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import { autobind } from 'core-decorators';
import CultureSwiperStore from '@src/business-components/navibar/components/culture-swiper/store';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import { useEffect } from 'react';
import { useMount } from 'ahooks';
import request from '@src/utils/request';
import { aLink } from '@src/utils/common-util';
import reload from '@src/utils/reload';
import $$tracker from '@src/tracker';
class NaviBarStore extends BaseStore {
  constructor({ ...rest } = {}) {
    super();
    Object.assign(this, rest);
  }
  cultureSwiperStore = new CultureSwiperStore();

  @observable isLoading = true;

  @observable isExpand = false;

  @observable layerData = {};
  @observable navList = [];
  @observable rightNavList = [];
  @observable expandedNavList = [];
  @observable cultureSwiperList = [];

  @observable account;

  @observable mode = 'social';

  @computed
  get isLogin() {
    // 判断是否存在用户账号名来确认是否存在
    return !!window.XPASS.u_account;
  }

  @autobind
  onLogoMenuHover() {
    this.isExpand = true;
  }

  @autobind
  closeExpandMenu() {
    this.isExpand = false;
  }

  /**
   * 点击金山登陆
   */
  clickLogin() {
    $$tracker.clickDldl();
    window.XPASS.signin({
      onLoginSuccess: async () => {
        this.getUserInfo();
      }
    });
    // window.XPASS.signin();
  }

  /**
   * 金山登录后获取用户信息
   */
  getUserInfo() {
    return request
      .post('api/ssg_recruiting_cn/v1/biz/get_current_user', {})
      .then(res => {
        window.userAccount = res.data.account;
        // console.log(res);
        this.account = res.data.account;
      })
      .catch(error => {
        console.error('GET 请求失败', error);
      });
  }

  toLink(title, url) {
    if (url) {
      let currentTitle = this.mode === 'social' ? '社会招聘' : '校园招聘';
      if (title === currentTitle) {
        reload();
      } else {
        aLink(url);
      }
    }
  }
  /**
   * 退出登录
   */
  logout() {
    return request
      .post('api/ssg_recruiting_cn/v1/biz/logout', {})
      .then(res => {
        window.XPASS.exit();
      })
      .catch(error => {
        console.error('GET 请求失败', error);
      });
  }

  /**
   * 查看投递记录
   */
  // clickJobRecord() {
  //   this.redirect('jobRecord');
  // }

  clickJobRecord() {
    let url = this.mode === 'social' ? 'jobRecord.html' : 'campusRecord.html';
    this.jumpPage(url);

    // if (DEPLOY_ENV === 'master') {
    //   const url = this.mode === 'social' ? 'jobRecord.html' : 'campusRecord.html';
    //   this.jumpPage(url);
    // } else {
    //   this.redirect('jobRecord');
    // }

    // let fullPath = window.location.origin + window.location.pathname;
    // let urlWithoutFileName = fullPath.replace(/\/[^\/]+\.html$/, '/');
    // // 如果路径末尾没有斜杠，则添加斜杠（可选）
    // if (!urlWithoutFileName.endsWith('/')) {
    //   urlWithoutFileName += '/';
    // }
    // let nextUrl = urlWithoutFileName + url;
    // window.location.href = nextUrl;
  }

  use() {
    super.use();

    const data = useLayerData('header');
    const modeConfig = useLayerData('modeConfig');

    useMount(() => {
      this.isActive = true;
      this.getUserInfo();
    });

    // useEffect(
    //   () => {
    //     if (this.isLogin) {
    //       this.getUserInfo();
    //     }
    //   },
    //   [this.isLogin]
    // );
    useEffect(
      () => {
        this.isLoading = data == null;
        if (data) {
          this.layerData = data;
          this.navList = data.nav || [];
          this.rightNavList = data.right_nav || [];
          this.expandedNavList = data.expand_nav || [];
          this.cultureSwiperList = data.expand_swiper?.map(item => ({ title: item.main_title, img: item.image_src }));
        }
      },
      [data]
    );
    useEffect(
      () => {
        if (modeConfig) {
          this.mode = modeConfig.mode;
          // console.log('modeConfig', modeConfig);
        }
      },
      [modeConfig]
    );

    useEffect(
      () => {
        this.isLoading = data == null;
        if (data) {
          this.layerData = data;
          this.navList = data.nav || [];
          this.rightNavList = data.right_nav || [];
          this.expandedNavList = data.expand_nav || [];
          this.cultureSwiperList = data.expand_swiper?.map(item => ({ title: item.main_title, img: item.image_src }));
        }
      },
      [data]
    );
  }
}

export default NaviBarStore;
